import axios from "axios";
// import home from "../../home/home";
// import {calculateTimeDifferenceTwoDates, geDataFormat} from "../../../common/utils";
import sanzione1 from "../../common/mookup/sanzione_da_pagare_1";
import sanzione2 from "../../common/mookup/sanzione_da_pagare_2";
export default class RicercaSanzioneService {
  getSanzioni(stato, onSuccess) {
    if (stato === "1") {
      onSuccess(sanzione1);
    } else if (stato === "2") {
      onSuccess(sanzione2);
    }
  }
  searchSanzione(onSuccess, numeroSanzione,) {
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + `/public/api/v1/payment/findPagamento?identificativo=${numeroSanzione}`, configHeaders)
      .then(
        function (result) {
          if(result.status === 200){
            onSuccess(result);
          }
        },
        function (error) {
          console.log("errore  " + error);
          // onSuccess("");
        }
      );
  }

  redirectPagamentoSanzionePoste(data, onSuccess, onError){
    const host = "https://acquistionlinetest.poste.it/poste/pagamenti/main";
    const header= {
      headers: {
        'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    const axiosInstance = axios.create()
    axiosInstance.defaults.maxRedirects = 0;
    axiosInstance.interceptors.response.use(
        (response) => {
          if(response.status === 200){
            const redirectURL = response.request.responseURL
            window.location.href = redirectURL
          }
          return response
        },
        (error) => {
          if(error.response && [301, 302].includes(error.response.status)){
            const redirectURL = error.response.header.location
            window.location.href=redirectURL
          }
          return Promise.reject(error)
        }
    )
    axiosInstance.post(host, data, header).then(
        function (result) {
          // onSuccess(result);
          return result
        },
        function (error) {
          onError(error)
        }
    );
  }

  pagaSanzione(idSanzione,importo,onSuccess,onError) {
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + `/public/api/v1/payment/send?identificativo=${idSanzione}&imp=${importo}` , configHeaders)
      .then(
        function (result) {
          onSuccess(result);
        },
        function (error) {
          onError(idSanzione)
        }
      );
  }
}
